export const normalizePhoneForWhatsapp = (phone?: string): string => {
  if (!phone?.trim()) return "";

  let cleaned = phone.replace(/[^\d+]/g, "");
  cleaned = cleaned.replace(/^\+/, "");

  if (cleaned.startsWith("0")) {
    cleaned = `263${cleaned.slice(1)}`;
  }

  return cleaned;
};

export const openWhatsappChat = (
  phone: string | undefined,
  message?: string,
): void => {
  const normalizedPhone = normalizePhoneForWhatsapp(phone);
  if (!normalizedPhone) return;

  const encoded = encodeURIComponent(message ?? "");
  const url = `https://wa.me/${normalizedPhone}?text=${encoded}`;
  window.open(url, "_blank", "noopener,noreferrer");
};
